export const SkeletonItem = ({ heightClass = 'h-4', widthClass = 'w-full', shadeClass = 'bg-gray-200' } : { heightClass?: string, widthClass?: string, shadeClass?: string }) => {
  return (
    <div className='animate-pulse flex space-x-4'>
      <div className='flex-1 space-y-4 py-1'>
        <div className={`${heightClass} ${shadeClass} rounded ${widthClass}`} />
      </div>
    </div>
  )
}
